(function(){
"use strict";

angular.module('SmartAdmin.UI').directive('smartTooltipHtml', smartTooltipHtml);

    function smartTooltipHtml () {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attributes) {
                element.tooltip({
                    placement: attributes.tooltipPlacement || 'top',
                    html: true,
                    title: attributes.smartTooltipHtml
                })
            }
        };

})();
